import { FC, ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { AlertTriangle } from 'lucide-react';

interface FallbackProps {
  error: any;
  resetError: () => void;
}

const ErrorFallback = ({ error, resetError }: FallbackProps) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground p-4">
      <div className="max-w-md w-full bg-card text-card-foreground shadow-lg rounded-xl p-8 border border-border text-center flex flex-col items-center">
        <AlertTriangle className="w-12 h-12 text-destructive mb-4" />
        <h1 className="text-2xl font-bold mb-2">Something went wrong.</h1>
        <p className="text-muted-foreground mb-6">
          An unexpected error occurred. Our engineering team has been notified.
        </p>

        {import.meta.env.DEV && error && (
          <pre className="mt-2 mb-6 overflow-auto rounded bg-muted p-4 text-xs text-muted-foreground max-h-48 text-left w-full whitespace-pre-wrap break-all border border-border">
            {error.message}
          </pre>
        )}

        <button
          onClick={() => {
            resetError();
            window.location.reload();
          }}
          className="px-4 py-2 bg-primary text-primary-foreground font-medium rounded-md hover:bg-primary/90 transition-colors"
        >
          Reload Application
        </button>
      </div>
    </div>
  );
};

export const GlobalErrorBoundary: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog={false}>
      {children}
    </Sentry.ErrorBoundary>
  );
};
